export const APP_BASE_URL = import.meta.env.VITE_APP_BASE_URL ?? "";
export const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY ?? "";
export const TELEPHONE_NUMBER = "+81(0)80-5357-6420";
export const EMAIL_ADDRESS = "daniel@hakubasnowsports.com";
export const COMPANY_NAME = "HAKUBA SNOW SPORTS SCHOOL";
export const COMPANY_ADDRESS = "1-1-1 Hakuba, Karuizawa, Nagano, Japan";
export const CURRENCY_SYMBOL = import.meta.env.VITE_CURRENCY_SYMBOL ?? "¥";
